// A Rendszer képernyők kérései viszik az `X-Platform-View` fejlécet: belépve, Global állásban a szerver ezeket úgy
// futtatja, mint belépés nélkül, tehát ugyanazt adják, amit a global admin kívülről látna. Az intézményi adatot mutató
// Rendszer-listák (`meta.tenantData`) csak olvasva: az ott indított írás a belépett intézményé.
let mode = null;

export function trackPlatformRoute(route) {
    mode = route?.matched?.[1]?.meta?.type === 'global' ? (route.meta?.tenantData ? 'read' : 'all') : null;
}

export function sendsPlatformView(method) {
    return mode === 'all' || (mode === 'read' && ['get', 'head'].includes(String(method || 'get').toLowerCase()));
}

/**
 * Platform szinten dolgozik-e a felhasználó (#159): nincs kiválasztott intézmény, vagy belépve, Global nézetben egy
 * Rendszer-képernyőn (a szerver ott ugyanígy dönt: `currentTenantId()` null). Az orvos globális adata ilyenkor írható,
 * intézményi szinten csak a kiválasztott intézmény eltérése.
 */
export function isPlatformLevel(currentTenantId, authenticated, route) {
    // a választó állapota (`tenant/current`): a belépéskor kapott tenant_context a váltás után nem frissül
    if (!currentTenantId) {
        return true;
    }

    const systemScreen = route?.matched?.[1]?.meta?.type === 'global' && !route?.meta?.tenantData;

    return systemScreen && authenticated?.tenant_context?.view === 'global';
}
